var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChatForwardLine = function SvgChatForwardLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.841 15.25 2.5 17.875V4a.75.75 0 0 1 .75-.75h13.5a.75.75 0 0 1 .75.75v10.5a.75.75 0 0 1-.75.75zM4 14.789l1.322-1.039H16v-9H4zM10 8.5V6.25l3 3-3 3V10H7V8.5z"
  })));
};
export default SvgChatForwardLine;